import React from 'react';
import Loadable from 'react-loadable'
import viewAssistant from '../views/Teacher/Assistants/ViewAssistant/viewAssistant';
// import groupDetails from '../views/Common/Groups/GroupDetails/groupDetails';
// import addOffline from '../views/Common/Subjects/Exams/AddOffline/addOffline';
// import AddLesson from '../views/Common/Subjects/AllLessons/AddLesson/AddLesson';


function Loading() {
    return <div className="loading">
        {/* <div className="spinner-grow text-muted"></div>
        <div className="spinner-grow text-primary"></div>
        <div className="spinner-grow text-success"></div> */}
    </div>;
}
//test 
const test = Loadable({
    loader: () => import('../views/Teacher/teacher'),
    loading: Loading,
});
// Home
const Home = Loadable({
    loader: () => import('../views/Common/AllPosts/AllPosts'),
    loading: Loading,
});
// Settings
const Settings = Loadable({
    loader: () => import('../views/Teacher/Settings/SettingsView/Settings'),
    loading: Loading,
});

const MyAccount = Loadable({
    loader: () => import('../views/Teacher/Settings/MyAccount/MyAccount'),
    loading: Loading,
});

// Assistans
const Assistans = Loadable({
    loader: () => import('../views/Teacher/Assistants/AllAssistants/Assistants'),
    loading: Loading,
});
const AddAssistants = Loadable({
    loader: () => import('../views/Teacher/Assistants/AddAssistant/addAssistant'),
    loading: Loading,
});
// const ViewAssistants = Loadable({
//     loader: () => import('../views/Teacher/Assistants/ViewAssistant/viewAssistant'),
//     loading: Loading,
// });
const EditAssistants = Loadable({
    loader: () => import('../views/Teacher/Assistants/UpdateAssistant/updateAssistant'),
    loading: Loading,
});

// AllStudents
const AllStudents = Loadable({
    loader: () => import('../views/Teacher/AllStudents/ViewStudents/AllStudents'),
    loading: Loading,
});

const StudentProfile = Loadable({
    loader: () => import('../views/Teacher/AllStudents/StudentProfile/StudentProfile'),
    loading: Loading,
});

const StudentResults = Loadable({
    loader: () => import('../views/Teacher/AllStudents/StudentsResults/StudentsResults'),
    loading: Loading,
});

const SendMSG = Loadable({
    loader: () => import('../views/Teacher/AllStudents/SendMSG/SendMSG'),
    loading: Loading,
});

const StudentAttendance = Loadable({
    loader: () => import('../views/Teacher/AllStudents/StudentAttendance/StudentAttendance'),
    loading: Loading,
})
const PaymentWay = Loadable({
    loader: () => import('../views/Common/Payment/PaymentWay'),
    loading: Loading,
})

const AddSubject = Loadable({
    loader: () => import('../views/Common/Levels/AddSubject/Addsubject'),
    loading: Loading,
});
const LevelSubject = Loadable({
    loader: () => import('../views/Common/Levels/LevelSubject/subjects'),
    loading: Loading,
})
const AddLevel = Loadable({
    loader: () => import('../views/Common/Levels/AddLevel/AddLevel'),
    loading: Loading,
})
const AddSubLevel = Loadable({
    loader: () => import('../views/Common/Levels/AddSubLevel/AddSubLevel'),
    loading: Loading,
})


// To Do
const MyToDo = Loadable({
    loader: () => import('../views/Common/MyToDo/ViewMyToDo/viewMyToDo'),
    loading: Loading,
})
const AddMyToDo = Loadable({
    loader: () => import('../views/Common/MyToDo/AddMyToDo/addMyToDo'),
    loading: Loading,
})
const ALLAssistantToDo = Loadable({
    loader: () => import('../views/Teacher/ToDo/AssistantToDo/AllAssistants/Assistants'),
    loading: Loading,
})
const AssistantToDo = Loadable({
    loader: () => import('../views/Teacher/ToDo/AssistantToDo/ViewAssitantToDo/viewAssitantToDo'),
    loading: Loading,
})

const AddAssistantToDoStep1 = Loadable({
    loader: () => import('../views/Teacher/ToDo/AssistantToDo/AddAssitantToDo/addAssitantToDoStep1'),
    loading: Loading,
})
const AddAssistantToDoStep2 = Loadable({
    loader: () => import('../views/Teacher/ToDo/AssistantToDo/AddAssitantToDo/addAssitantToDoStep2'),
    loading: Loading,
})
const AddAssistantToDoStep3 = Loadable({
    loader: () => import('../views/Teacher/ToDo/AssistantToDo/AddAssitantToDo/addAssitantToDoStep3'),
    loading: Loading,
})

const ALLStudentsToDo = Loadable({
    loader: () => import('../views/Teacher/ToDo/StudentsToDo/AllStudents/Students'),
    loading: Loading,
})
const StudentToDo = Loadable({
    loader: () => import('../views/Teacher/ToDo/StudentsToDo/ViewStudentToDo/viewStudentToDo'),
    loading: Loading,
})
const AddStudentToDoStep1 = Loadable({
    loader: () => import('../views/Teacher/ToDo/StudentsToDo/AddStudentToDo/addStudentToDoStep1'),
    loading: Loading,
})
const AddStudentToDoStep2 = Loadable({
    loader: () => import('../views/Teacher/ToDo/StudentsToDo/AddStudentToDo/addStudentToDoStep2'),
    loading: Loading,
})
const AddStudentToDoStep3 = Loadable({
    loader: () => import('../views/Teacher/ToDo/StudentsToDo/AddStudentToDo/addStudentToDoStep3'),
    loading: Loading,
})
// GROUPS
const AllGroups = Loadable({
    loader: () => import('../views/Common/Groups/AllGroups/allGroups'),
    loading: Loading,
})
const AddStudentsToGroups = Loadable({
    loader: () => import('../views/Common/Groups/StudentsGroup/AddStudenttoGroup/addstudent'),
    loading: Loading,
})
const StudentsGroups = Loadable({
    loader: () => import('../views/Common/Groups/StudentsGroup/students'),
    loading: Loading,
})
const StudentSingleGroup = Loadable({
    loader: () => import('../views/Student/Groups/ViewAllGroups/viewGroup'),
    loading: Loading,
})
const StudentChangeGroup = Loadable({
    loader: () => import('../views/Student/Groups/ChangeGroup/viewAllGroups'),
    loading: Loading,
})
const StudentResultGroups = Loadable({
    loader: () => import('../views/Common/Groups/StudentsGroup/Results/AllResults'),
    loading: Loading,
})
const AssistantsGroups = Loadable({
    loader: () => import('../views/Common/Groups/AssistantsGroup/assistants'),
    loading: Loading,
})
const ExtraLecture = Loadable({
    loader: () => import('../views/Common/Groups/ExtraLecture/extraLecture'),
    loading: Loading,
})
const GroupsDetails = Loadable({
    loader: () => import('../views/Common/Groups/GroupDetails/groupDetails'),
    loading: Loading,
})
const AddGroup = Loadable({
    loader: () => import('../views/Common/Groups/AddGroup/addGroup'),
    loading: Loading,
})
const EditGroup = Loadable({
    loader: () => import('../views/Common/Groups/EditGroup/editGroup'),
    loading: Loading,
})
const GroupMovement = Loadable({
    loader: () => import('../views/Common/Groups/GroupMovement/moveGroup'),
    loading: Loading,
})
const ParentView = Loadable({
    loader: () => import('../views/Common/Groups/StudentsGroup/ParentView/parent'),
    loading: Loading,
})
//Attendance
const Attendance = Loadable({
    loader: () => import('../views/Common/Attendance/viewAttendance/viewAttendance'),
    loading: Loading,
})
const AttendancePerDate = Loadable({
    loader: () => import('../views/Common/AttendanceperDate/ViewAllGroups/viewAllGroups'),
    loading: Loading,
})
const AttendanceSrudents = Loadable({
    loader: () => import('../views/Common/AttendanceperDate/AllStudents/AllStudents'),
    loading: Loading,
})
// Explanation
const AllChapters = Loadable({
    loader: () => import('../views/Common/Subjects/AllChapters/ViewAllChapters/allChapters'),
    loading: Loading,
})
const AddChapter = Loadable({
    loader: () => import('../views/Common/Subjects/AllChapters/AddChapter/AddChapter'),
    loading: Loading,
})
const EditChapter = Loadable({
    loader: () => import('../views/Common/Subjects/AllChapters/EditChapter/editChapter'),
    loading: Loading,
})
const AllLessons = Loadable({
    loader: () => import('../views/Common/Subjects/AllLessons/ViewAllLessons/allLessons'),
    loading: Loading,
})
const AddLessons = Loadable({
    loader: () => import('../views/Common/Subjects/AllLessons/AddLesson/AddLesson'),
    loading: Loading,
})
const AllPDFs = Loadable({
    loader: () => import('../views/Common/Subjects/PDFS/ViewAllPDFs/allPDFs'),
    loading: Loading,
})
const AddPDF = Loadable({
    loader: () => import('../views/Common/Subjects/PDFS/AddPDF/AddPDF'),
    loading: Loading,
})
const PDFDetails = Loadable({
    loader: () => import('../views/Common/Subjects/PDFS/PDFDetails/PDFDetails'),
    loading: Loading,
})
const EditPDF = Loadable({
    loader: () => import('../views/Common/Subjects/PDFS/UpdatePDF/updatePDF'),
    loading: Loading,
})
const AllVideos = Loadable({
    loader: () => import('../views/Common/Subjects/Videos/ViewAllVideos/allVideos'),
    loading: Loading,
})
const AddVideo = Loadable({
    loader: () => import('../views/Common/Subjects/Videos/AddVideo/AddVideo'),
    loading: Loading,
})
const VideoDetails = Loadable({
    loader: () => import('../views/Common/Subjects/Videos/VideoDetails/VideoDetails'),
    loading: Loading,
})
const EditVideo = Loadable({
    loader: () => import('../views/Common/Subjects/Videos/UpdateVideo/updateVideo'),
    loading: Loading,
})
// Exmas
const Exams = Loadable({
    loader: () => import('../views/Common/Subjects/Exams/ExmasTypes/examsTypes'),
    loading: Loading,
})
const AllExams = Loadable({
    loader: () => import('../views/Common/Subjects/Exams/ViewAllExams/allExams'),
    loading: Loading,
})
const AddOfflineExams = Loadable({
    loader: () => import('../views/Common/Subjects/Exams/AddOffline/addOffline'),
    loading: Loading,
})
const AddOnlineExams = Loadable({
    loader: () => import('../views/Common/Subjects/Exams/AddOnline/addOnline'),
    loading: Loading,
})
const AddOfflineGrades = Loadable({
    loader: () => import('../views/Common/Subjects/Exams/AddOfflineGrades/addOffGrades'),
    loading: Loading,
})
const ShowOfflineGrades = Loadable({
    loader: () => import('../views/Common/Subjects/Exams/ShowOfflineGrades/showOffGrades'),
    loading: Loading,
})
const CorrectOnlineExam = Loadable({
    loader: () => import('../views/Common/Subjects/Exams/correctonLineExam/correctonLineExam'),
    loading: Loading,
})
const CorrectTextQuestion = Loadable({
    loader: () => import('../views/Common/Subjects/Exams/correctonLineExam/correctTextQuestion'),
    loading: Loading,
})
const correctCompleteQuestion = Loadable({
    loader: () => import('../views/Common/Subjects/Exams/correctonLineExam/correctCompleteQuestion'),
    loading: Loading,
})
const ShowExam = Loadable({
    loader: () => import('../views/Common/Subjects/Exams/ShowExam/showExam'),
    loading: Loading,
})
//QUESTIONS
const Questions = Loadable({
    loader: () => import('../views/Common/Subjects/Questions/Questions/Questions'),
    loading: Loading,
})
const NotAnsweredQuestions = Loadable({
    loader: () => import('../views/Common/Subjects/Questions/NotAnsweredQuestion/Notanswered'),
    loading: Loading,
})
const SingleNotAnsweredQuestions = Loadable({
    loader: () => import('../views/Common/Subjects/Questions/SingleQuestion/singleQuestion'),
    loading: Loading,
})
const StudentAnswers = Loadable({
    loader: () => import('../views/Common/Subjects/Questions/NotAnsweredQuestion/StudentsAnswers/studentsAnswers'),
    loading: Loading,
})
const addQuestion = Loadable({
    loader: () => import('../views/Common/Subjects/Questions/Questions/AddQuestion/AddQuestion'),
    loading: Loading,
})

const Notifications = Loadable({
    loader: () => import('../components/DefaultLayout/NotificationPage/AllNotifications'),
    loading: Loading,
})

// Students' EXAMS
const ExamView = Loadable({
    loader: () => import('../views/Student/Exams/ExamsView/examsView'),
    loading: Loading,
})
const AllStudentExams = Loadable({
    loader: () => import('../views/Student/Exams/AllExams/allExams'),
    loading: Loading,
})
const AllStudentResults = Loadable({
    loader: () => import('../views/Student/Exams/Results/AllResults'),
    loading: Loading,
})
const OnlineExamsStatus = Loadable({
    loader: () => import('../views/Student/Exams/ExmasStatus/examsStatus'),
    loading: Loading,
})
const AnwserExam = Loadable({
    loader: () => import('../views/Student/Exams/AnswerExam/answerExam'),
    loading: Loading,
})

const CorrectedExam = Loadable({
    loader: () => import('../views/Student/Exams/CorrectedExam/correctedExam'),
    loading: Loading,
})

const ExamDetails = Loadable({
    loader: () => import('../views/Student/Exams/ExamDetails/examDetails'),
    loading: Loading,
})
// Students' TEACHERS
const TeachersView = Loadable({
    loader: () => import('../views/Student/Teachers/ViewAllTechers/viewAllTeachers'),
    loading: Loading,
})
const ViewTeacherProfile = Loadable({
    loader: () => import('../views/Student/Teachers/ViewTeacherProfile/viewTeacherProfile'),
    loading: Loading,
})
const StudentGroups = Loadable({
    loader: () => import('../views/Student/Groups/ViewAllGroups/viewAllGroups'),
    loading: Loading,
})
const ViewChapters = Loadable({
    loader: () => import('../views/Student/Explaintaion/AllChapters/viewAllChapters'),
    loading: Loading,
})
const ViewStudentChaptersLessons = Loadable({
    loader: () => import('../views/Student/Explaintaion/AllLessons/allchaptersLessons'),
    loading: Loading,
})
const ViewStudentVideo = Loadable({
    loader: () => import('../views/Student/Explaintaion/AllVideos/ViewAllVideos/allVideos'),
    loading: Loading,
})
const ViewStudentVideoDetails = Loadable({
    loader: () => import('../views/Student/Explaintaion/AllVideos/VideoDetails/VideoDetails'),
    loading: Loading,
})
const ViewStudentPDFs = Loadable({
    loader: () => import('../views/Student/Explaintaion/AllPDFs/ViewAllPDFs/allPDFs'),
    loading: Loading,
})
const ViewStudentPDFDetails = Loadable({
    loader: () => import('../views/Student/Explaintaion/AllPDFs/PDFDetails/PDFDetails'),
    loading: Loading,
})
 const ViewSinglePost = Loadable({
    loader: () => import('../views/Common/AllPosts/SinglePost/SinglePost'),
    loading: Loading,
})
// Parents
const AllTeachers = Loadable({
    loader: () => import('../views/Parent/AllTeachers/AllTeachers'),
    loading: Loading,
});

const TeacherProfile = Loadable({
    loader: () => import('../views/Parent/TeacherProfile/TeacherProfile'),
    loading: Loading,
});

const StudentGrades = Loadable({
    loader: () => import('../views/Parent/StudentGrades/StudentGrades'),
    loading: Loading,
});

const AllPosts = Loadable({
    loader: () => import('../views/Common/AllPosts/AllPosts'),
    loading: Loading,
});

const EditLesson = Loadable({
    loader: () => import('../views/Common/Subjects/AllLessons/EditLesson/EditLesson'),
    loading: Loading,
});
//Levels Settings
const LevelSettings = Loadable({
    loader: () => import('../views/Teacher/LevelsSeetings/AllLevels'),
    loading: Loading,
});
const EditSubject = Loadable({
    loader: () => import('../views/Common/Levels/EditSubject/EditSubject'),
    loading: Loading,
});

//aboutUS
const AboutUS = Loadable({
    loader: () => import('../views/Common/AboutUS/aboutUS'),
    loading: Loading,
});
//contact US
const ContactUS = Loadable({
    loader: () => import('../views/Common/ContactUS/contactUS'),
    loading: Loading,
});
//Top
const TopStudents = Loadable({
    loader: () => import('../views/Common/Top/TopStudents'),
    loading: Loading,
});
//Dashboard
const Dashboard = Loadable({
    loader: () => import('../views/Teacher/Dashboard/dashboard'),
    loading: Loading,
});
//groups change requests
const ChangeGroupRequests = Loadable({
    loader: () => import('../views/Common/Groups/ChangeGroupsRequestes/allrequests'),
    loading: Loading,
});
//Search
const Search = Loadable({
    loader: () => import('../views/Common/PublicSearch/publicSearch'),
    loading: Loading,
});
//Exercies
const Exercies = Loadable({
    loader: () => import('../views/Common/Exerices/ViewAllExams/allExams'),
    loading: Loading,
});
const AddExercies = Loadable({
    loader: () => import('../views/Common/Exerices/AddOnline/addOnline'),
    loading: Loading,
});

const AllStudentExercies = Loadable({
    loader: () => import('../views/Student/Exercies/AllExams/allExams'),
    loading: Loading,
})
const AnwserExercies = Loadable({
    loader: () => import('../views/Student/Exercies/AnswerExam/answerExam'),
    loading: Loading,
})

const ExerciesAnswer = Loadable({
    loader: () => import('../views/Student/Exercies/CorrectedExam/correctedExam'),
    loading: Loading,
})
//AssistantsAddRules
const AssistantsAddRules = Loadable({
    loader: () => import('../views/Teacher/Assistants/AssignRules/assignRules'),
    loading: Loading,
})

const Test = Loadable({
    loader: () => import('../views/Teacher/teacher'),
    loading: Loading,
})

//////Parent new pages 

const AllChilderns = Loadable({
    loader: () => import('../views/Parent/AllChilds/ViewAllChilds/AllChildrens'),
    loading: Loading,
})
const AddChilderns = Loadable({
    loader: () => import('../views/Parent/AllChilds/AddChildern/AddChildern'),
    loading: Loading,
})

const ChildernSubject = Loadable({
    loader: () => import('../views/Parent/ChildernSubjects/ChildernSubjects'),
    loading: Loading,
})

const EditMyToDo=Loadable({
    loader: () => import('../views/Teacher/ToDo/MyToDo/EditMyToDo/EditMyToDo.js'),
    loading: Loading,
})
const  GroupPayment = Loadable({
    loader :()=> import ("../views/Common/Groups/AllGroups/GroupPayment/groupPayment"),
    loading : Loading ,
})
const routes = [
    //test
    { path: '/test', exact: true, name: 'Home', component: Test },
    // Home
    { path: '/home', exact: true, name: 'Home', component: Home },

    // Notifications
    { path: '/Notifications', exact: true, name: 'Notifications', component: Notifications },

    // Settings
    { path: '/Settings', exact: true, name: 'Settings', component: Settings },
    { path: '/MyAccount', exact: true, name: 'MyAccount', component: MyAccount },

    // Assistans
    { path: '/Assistans', exact: true, name: 'Assistans', component: Assistans },
    { path: '/add-assistants', exact: true, name: 'AddAssistants', component: AddAssistants },
    { path: '/view-assistant', exact: true, name: 'ViewAssistant', component: viewAssistant },
    { path: '/update-assistant', exact: true, name: 'updateAssistant', component: EditAssistants },

    // AllStudents
    { path: '/AllStudents', exact: true, name: 'AllStudents', component: AllStudents },
    { path: '/StudentProfile/:id', exact: true, name: 'StudentProfile', component: StudentProfile },
    { path: '/StudentResults/:id', exact: true, name: 'StudentResults', component: StudentResults },
    // { path: '/SendMSG/:id', exact: true, name: 'SendMSG', component: SendMSG },
    { path: '/conversation', exact: true, name: 'SendMSG', component: SendMSG },
    { path: '/AllStudents/StudentAttendance', exact: true, name: 'StudentAttendance', component: StudentAttendance },
    { path: '/PaymentWay', exact: true, name: 'PaymentWay', component: PaymentWay },

    { path: '/Levels/add-subjects', exact: true, name: 'Level subject', component: AddSubject },
    { path: '/Levels/subjects/:name', exact: true, name: 'Level subject', component: LevelSubject },

    { path: '/Add-Level', exact: true, name: 'Level subject', component: AddLevel },
    { path: '/Add-SubLevel', exact: true, name: 'Level subject', component: AddSubLevel },

    // ToDo
    { path: '/ToDo/myToDo', exact: true, name: 'my ToDo', component: MyToDo },
    { path: '/ToDo/addMyToDo', exact: true, name: 'Add My ToDo', component: AddMyToDo },
    { path: '/ToDo/assistantToDo', exact: true, name: 'Assistant ToDo', component: AssistantToDo },
    { path: '/ToDo/all-assistants', exact: true, name: 'All Assistant ToDo', component: ALLAssistantToDo },
    { path: '/ToDo/add-assistants-To-DO/1', exact: true, name: 'Add Assistant ToDo', component: AddAssistantToDoStep1 },
    { path: '/ToDo/add-assistants-To-DO/2', exact: true, name: 'Add Assistant ToDo', component: AddAssistantToDoStep2 },
    { path: '/ToDo/add-assistants-To-DO/3', exact: true, name: 'Add Assistant ToDo', component: AddAssistantToDoStep3 },
    { path: '/ToDo/all-students', exact: true, name: 'All Student ToDo', component: ALLStudentsToDo },
    { path: '/ToDo/studentToDo', exact: true, name: 'Student ToDo', component: StudentToDo },
    { path: '/ToDo/add-students-ToDO/step1', exact: true, name: 'Add students ToDo', component: AddStudentToDoStep1 },
    { path: '/ToDo/add-students-To-DO/step2', exact: true, name: 'Add students ToDo', component: AddStudentToDoStep2 },
    { path: '/ToDo/add-students-To-DO/3', exact: true, name: 'Add students ToDo', component: AddStudentToDoStep3 },
    { path: '/EditMyToDo', exact: true, name: 'EditMyToDo', component: EditMyToDo },

    
    //GROUPS
    { path: '/groups/all-groups', exact: true, name: 'All groups', component: AllGroups },
    { path: '/groups/students', exact: true, name: 'All students', component: StudentsGroups },
    { path: '/groups/add-students', exact: true, name: 'All students', component: AddStudentsToGroups },
    { path: '/groups/parent', exact: true, name: 'parent', component: ParentView },
    { path: '/groups/assistants', exact: true, name: 'All assistants', component: AssistantsGroups },
    { path: '/groups/add-lecture', exact: true, name: 'Add lecture', component: ExtraLecture },
    { path: '/groups/details/:id', exact: true, name: 'griup details', component: GroupsDetails },
    { path: '/groups/add-groups', exact: true, name: 'Add groups', component: AddGroup },
    { path: '/groups/edit-groups', exact: true, name: 'edit groups', component: EditGroup },
    { path: '/groups/movefrom-group', exact: true, name: 'move groups', component: GroupMovement },
    { path: '/groups/students/:name/result', exact: true, name: 'student result', component: StudentResultGroups },
    { path: '/groups/students/attendance', exact: true, name: 'student attendance', component: Attendance },
    { path: '/groups/payment/:id', exact: true, name: 'student attendance', component: GroupPayment },



    // Explaniation
    { path: '/subject/all-chapters', exact: true, name: 'All Chapters', component: AllChapters },
    { path: '/subject/add-Chapter', exact: true, name: 'Add Chapter', component: AddChapter },
    { path: '/chapter/edit', exact: true, name: 'Edit Chapter', component: EditChapter },
    { path: '/subject/all-lessons', exact: true, name: 'All Lessons', component: AllLessons },
    { path: '/subject/lesson/add-Lesson', exact: true, name: 'Add Lesson', component: AddLessons },
    { path: '/subject/all-PDFs', exact: true, name: 'All PDFs', component: AllPDFs },
    { path: '/subject/add-PDF', exact: true, name: 'Add PDF', component: AddPDF },
    { path: '/subject/PDFDetails', exact: true, name: 'PDF Details', component: PDFDetails },
    { path: '/subject/edit-PDF', exact: true, name: 'PDF Update', component: EditPDF },
    { path: '/subject/all-videos', exact: true, name: 'All Videos', component: AllVideos },
    { path: '/subject/add-video', exact: true, name: 'Add Videos', component: AddVideo },
    { path: '/subject/video-Details', exact: true, name: 'Video Details', component: VideoDetails },
    { path: '/subject/edit-Video', exact: true, name: 'Video Update', component: EditVideo },
    { path: '/subject/edit-Lesson', exact: true, name: 'Video Update', component: EditLesson },
    { path: '/subject/edit-Subject', exact: true, name: 'Video Update', component: EditSubject },

    //Questions
    { path: '/Levels/questions', exact: true, name: 'Answered questions', component: Questions },
    { path: '/Levels/questions/notanswered', exact: true, name: 'not answered questions', component: NotAnsweredQuestions },
    { path: '/Levels/questions/sibgleQuestion/:id', exact: true, name: 'not answered questions', component: SingleNotAnsweredQuestions },
    { path: '/Levels/questions/srudentsanswers', exact: true, name: 'Student Answers', component: StudentAnswers },
    { path: '/Levels/questions/addQuestion', exact: true, name: 'Answered questions', component: addQuestion },


    // Exams
    { path: '/Levels/Exams', exact: true, name: 'Exams', component: Exams },
    { path: '/Levels/Exams/add-offline', exact: true, name: 'Add offline Exams', component: AddOfflineExams },
    { path: '/Levels/Exams/add-online', exact: true, name: 'Add online Exams', component: AddOnlineExams },
    { path: '/Levels/Exams/add-offlinegrades', exact: true, name: 'Add offline grades', component: AddOfflineGrades },
    { path: '/Levels/Exams/show-offlineGrades', exact: true, name: 'Show offline grades', component: ShowOfflineGrades },
    { path: '/Levels/Exams/:status', exact: true, name: 'All Exams', component: AllExams },
    { path: '/Levels/OnlineExams/correct', exact: true, name: 'Correct Exams', component: CorrectOnlineExam },
    { path: '/Levels/Exams/OnlineExams/correct/text-Questions', exact: true, name: 'Correct Text Questions ', component: CorrectTextQuestion },
    { path: '/Levels/Exams/OnlineExams/correct/complete-Questions', exact: true, name: 'complete Text Questions ', component: correctCompleteQuestion },
    { path: '/ALL-Exams/:name', exact: true, name: 'Show Exam ', component: ShowExam },
    // Students' EXAMS
    // { path: '/Exams', exact: true, name: 'Exams', component: ExamView },
    // { path: '/Exams/:status', exact: true, name: 'All Exams', component: AllStudentExams },

    // Students' Teachers
    { path: '/Subject/Teachers/:subject', exact: true, name: 'All Subject Teachers', component: TeachersView },


    // Parents
    { path: '/teacher', exact: true, name: 'AllTeachers', component: AllTeachers },
    { path: '/TeacherProfile', exact: true, name: 'TeacherProfile', component: TeacherProfile },
    { path: '/StudentGrades', exact: true, name: 'StudentGrades', component: StudentGrades },

    // Students' EXAMS
    { path: '/Exams', exact: true, name: 'Exams', component: ExamView },
    { path: '/Exams/results', exact: true, name: 'All results', component: AllStudentResults },
    { path: '/Exams/:status', exact: true, name: 'All Exams', component: AllStudentExams },

    // Students' Teachers
    { path: '/Subject/Teachers/:subject', exact: true, name: 'All Subject Teachers', component: TeachersView },
    { path: '/Teachers/:name', exact: true, name: 'Teachers Profile', component: ViewTeacherProfile },
    { path: '/Subject/Groups/:subject', exact: true, name: 'Student Groups', component: StudentGroups },
    { path: '/Subject/Chapters', exact: true, name: 'All Chapters', component: ViewChapters },
    { path: '/Chapters/lessons', exact: true, name: 'All Student Lessons', component: ViewStudentChaptersLessons },
    { path: '/Subject/Videos', exact: true, name: 'All Videos', component: ViewStudentVideo },
    { path: '/Subject/Videos-details', exact: true, name: 'All Videos', component: ViewStudentVideoDetails },
    { path: '/Subject/PDF-details', exact: true, name: 'All PDFs', component: ViewStudentPDFDetails },
    { path: '/Subject/PDFs', exact: true, name: 'All PDFs', component: ViewStudentPDFs },
    { path: '/TeacherProfile/:id', exact: true, name: 'TeacherProfile', component: TeacherProfile },
    { path: '/results', exact: true, name: 'StudentGrades', component: StudentGrades },

    // Students' EXAMS
    { path: '/Exams', exact: true, name: 'Exams', component: ExamView },
    { path: '/Exams/results', exact: true, name: 'All results', component: AllStudentResults },
    { path: '/Exams/:status', exact: true, name: 'All Exams', component: AllStudentExams },
    { path: '/online/Status', exact: true, name: 'Online Exams Status', component: OnlineExamsStatus },
    { path: '/Online-Exams/Answer-exam', exact: true, name: 'Answer Online Exams', component: AnwserExam },
    { path: '/Online-Exams/corrected-exam', exact: true, name: 'corrected Online Exams', component: CorrectedExam },
    { path: '/exam-details', exact: true, name: 'Exam Details', component: ExamDetails },

    // Students' Teachers
    { path: '/Subject/Teachers/:subject', exact: true, name: 'All Subject Teachers', component: TeachersView },
    { path: '/Teachers/:name', exact: true, name: 'Teachers Profile', component: ViewTeacherProfile },
    { path: '/Subject/Groups', exact: true, name: 'Student Groups', component: StudentGroups },
    { path: '/Groups', exact: true, name: 'Student Groups', component: StudentSingleGroup },
    { path: '/groups/change-group', exact: true, name: 'change Groups', component: StudentChangeGroup },

    // All Posts
    { path: '/AllPosts', exact: true, name: 'All Posts', component: AllPosts },
    { path: '/post/:id', exact: true, name: 'All Posts', component: ViewSinglePost },
    //Levels Settings
    { path: '/Levels-settings', exact: true, name: 'All Posts', component: LevelSettings },
    //AboutUS
    { path: '/about-us', exact: true, name: 'All Posts', component: AboutUS },
    //AboutUS
    { path: '/contact-us', exact: true, name: 'All Posts', component: ContactUS },
    //Attendance
    { path: '/attendance', exact: true, name: 'All Posts', component: AttendancePerDate },
    { path: '/attendance-students', exact: true, name: 'All Posts', component: AttendanceSrudents },
    //Top
    { path: '/exam/Top-students', exact: true, name: 'Top Students', component: TopStudents },
    //Dashboard
    { path: '/Dashboard', exact: true, name: 'Dashboard', component: Dashboard },
    //groups change requests
    { path: '/group/changeRequests', exact: true, name: 'changeRequests', component: ChangeGroupRequests },
    //Search
    { path: '/Search', exact: true, name: 'Search', component: Search },
    //Exercies
    { path: '/Exsercies', exact: true, name: 'Search', component: Exercies },
    { path: '/add-exercies', exact: true, name: 'Add online Exams', component: AddExercies },
    { path: '/Exercies', exact: true, name: 'All StudentExercies', component: AllStudentExercies },
    { path: '/Answer-exercies', exact: true, name: 'Answer-exercies', component: AnwserExercies },
    { path: '/Exercies/answers', exact: true, name: 'ExerciesAnswer', component: ExerciesAnswer },
    //Assistant Rules
    { path: '/assistant/add-rules', exact: true, name: 'Add reules ', component: AssistantsAddRules },

    ////////parent new pages 
    { path: '/studentsparent', exact: true, name: 'View All Childerns ', component: AllChilderns },
    { path: '/parent/addChildern', exact: true, name: 'add Childerns ', component: AddChilderns },
    { path: '/student-subjects', exact: true, name: 'add Childerns ', component: ChildernSubject }



]

export default routes

